import React from 'react';
import Hero from './components/vc-message/Hero';
import Main from './components/vc-message/Main';
import ImportantLinksSlider from './components/Home/ImportantLinksSlider';

const VCMessage = () => {
    return (
        <div>
            <Hero />
            <Main />
            <ImportantLinksSlider />
        </div>
    )
}

export default VCMessage;